export enum FeedInGridConnectionTransformation {
  NoTransformerStation = 1,
  MediumToLowVoltage = 2,
  HighToMediumVoltage = 3,
}
